/* StatusFlowRenderer.js */

"use strict";
class StatusFlowRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("status-flow-gl");
        this._rootElem.setAttribute("tabindex", "-1");

        this._flowPoints = [];

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.on("setState", (this._onSetState = this._onSetState.bind(this)));

        this._model.on(
            "resetAllStates",
            (this._onResetAllStates = this._onResetAllStates.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("setState", this._onSetState);

        this._model.removeListener("resetAllStates", this._onResetAllStates);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;

            resolve();
        });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            const content = this._getContent(this._model._flowPoints, this._model._config);
            this._rootElem.innerHTML = "";
            this._rootElem.appendChild(content);
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here

    _getContent(data, config) {
        if (!Array.isArray(data)) {
            const errorEl = document.createElement("span");
            return (errorEl.innerText = "Couldn't Generate, Please verify the data");
        }
        this._flowPoints = this._generateFlowPointEls(data, config);
        const listEl = document.createElement("ul");
        listEl.classList.add("status-flow-gl");
        this._flowPoints.forEach((el) => {
            listEl.appendChild(el);
        });
        return listEl;
    }

    _generateFlowPointEls(data, config) {
        return data.map((item, idx) => {
            const itemConfig = config[item.toLowerCase()];
            return this._generateFlowPointEl(itemConfig, idx);
        });
    }

    _generateFlowPointEl(itemConfig, idx) {
        const el = document.createElement("li");
        el.classList.add(`flow-point-${idx}`);
        if (itemConfig.default.class) {
            el.classList.add(itemConfig.default.class);
        }
        el.innerHTML = `<span>${itemConfig.default.label}</span>`;
        return el;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onSetState({flowPoint, state}) {
        try {
            const elIndex = this._model._flowPoints.indexOf(flowPoint);
            const elConfig = this._model._config[flowPoint.toLowerCase()][state];
            const el = this._flowPoints[elIndex];
            el.className = "";
            el.classList.add(`flow-point-${elIndex}`);
            if (elConfig.class) {
                el.classList.add(elConfig.class);
            }
            el.innerHTML = `<span>${elConfig.label}</span>`;
        } catch (err) {
            console.warn(err);
            throw err;
        }
    }

    _onResetAllStates() {
        this._model._flowPoints.forEach((item) => {
            this._model.emit("setState", {flowPoint: item, state: "default"});
        });
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = StatusFlowRenderer;
